import * as React from 'react'
import { connect } from 'react-redux'

import { Form, Input, Label, FormGroup } from 'reactstrap'

import { OptionsType, ValueType } from 'react-select/lib/types'

import { RootState } from '../../../store/rootReducer'
import { Location, Position } from '../../../lib/interfaces/Location.interface'
import { BaseReportFilterParameters } from 'src/lib/interfaces/BaseReportFilterParameters.interface'

import CustomSelect from 'src/common/CustomSelect.component'

import * as appSelectors from 'src/store/app/selectors'

const get = require('lodash/get')
const first = require('lodash/first')
const isEmpty = require('lodash/isEmpty')

const moment = require('moment')

export interface ScanFilterProps {
  locations?: Location[]
  getLocationWithId: (locationId: number) => Location|undefined
}

export interface ScanFilterPassedProps {
  showEmployeeNameChecked?: boolean
  filterParams: BaseReportFilterParameters
  onChangeShowEmployeeName?: (show: boolean) => void
  onChange: (filters: BaseReportFilterParameters) => void
}

class ScanFilter extends React.PureComponent<ScanFilterProps & ScanFilterPassedProps> {
  constructor(props) {
    super(props)

    this.checkboxFilterChanged = this.checkboxFilterChanged.bind(this)
    this.multiSelectFilterChanged = this.multiSelectFilterChanged.bind(this)
    this.singleSelectFilterChanged = this.singleSelectFilterChanged.bind(this)
  }

  updateValueFromFilterChange(propertyName: string, value: any) {
    this.updateMultipleValuesFromFilterChange({ [propertyName]: value })
  }

  updateMultipleValuesFromFilterChange(values) {
    const { onChange, filterParams } = this.props
    const newFilterParams = {
      ...filterParams,
      ...values
    }
    
    onChange(newFilterParams)
  }

  checkboxFilterChanged(propertyName: string, event) {
    const value = event.target.value === 'on'
    this.updateValueFromFilterChange(propertyName, value)
  }

  singleSelectFilterChanged(propertyName: string, selectedOption: ValueType<any>) {
    this.updateValueFromFilterChange(propertyName, selectedOption.value)
  }

  multiSelectFilterChanged(propertyName: string, selectedOptions: OptionsType<any>) {
    this.updateValueFromFilterChange(propertyName, selectedOptions.map(({ value }) => value))
  }

  handleSelectLocation(value) {
    this.updateMultipleValuesFromFilterChange({
        location: value,
        position: undefined
    })
  }

  render() {
    const { locations, filterParams, getLocationWithId, showEmployeeNameChecked, onChangeShowEmployeeName } = this.props

    let currentPositions
    if (filterParams.location !== undefined) {
        const currentLocation = getLocationWithId(filterParams.location)
        currentPositions = currentLocation && currentLocation.locationPositions

        if (currentPositions) {
          currentPositions = [
            { id: undefined, name: 'All' },
            ...currentPositions
          ]
        }
    }

    return (
      <div>
        <Form>
          <FormGroup>
            <div className="row">
              <div className="col-3">
                <FormGroup>
                  <Label for="location">Location</Label>
                  <CustomSelect
                    options={locations}
                    style={{ width: '100%' }}
                    value={filterParams.location}
                    valueContainerStyle={{ textAlign: 'left' }}
                    getOptionValue={option => option && option.id }
                    getOptionLabel={option => option && option.code }
                    onChange={(value: number) => this.handleSelectLocation(value)}
                    placeholderStyle={{ fontWeight: 'light', fontStyle: 'italic' }}
                  />
                </FormGroup>
              </div>

              {filterParams.location &&
                <div className="col-3">
                  <FormGroup>
                    <Label for="position">Position</Label>
                    <CustomSelect
                      isMulti
                      style={{ width: '100%' }}
                      options={currentPositions}
                      valueContainerStyle={{ textAlign: 'left' }}
                      getOptionValue={option => option && option.id }
                      getOptionLabel={option => option && option.name }
                      placeholderStyle={{ fontWeight: 'light', fontStyle: 'italic' }}
                      value={isEmpty(filterParams.position) ? [undefined] : filterParams.position}
                      onChange={(value: number[]) => this.updateValueFromFilterChange('position', value)}
                    />
                  </FormGroup>
                </div>
            }
            </div>
          </FormGroup>

          <FormGroup>
            <div className="row">
              <div className="col-6">
                <div className="row">
                  <div className="col-6 d-flex flex-column">
                    <FormGroup>
                      <Label for="date-from">From</Label>
                      <Input
                        type="date"
                        value={moment(filterParams.fromDate).format('YYYY-MM-DD')}
                        onChange={e => this.updateValueFromFilterChange('fromDate', moment(e.target.value).format())}
                      />
                    </FormGroup>

                    {onChangeShowEmployeeName && (
                      <FormGroup check>
                        <Label check>
                          <Input type="checkbox" checked={showEmployeeNameChecked} onChange={e => onChangeShowEmployeeName(e.target.checked)} />{' '}
                          Show employee name
                        </Label>
                      </FormGroup>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </FormGroup>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
    locations: state.app.locations,
    getLocationWithId: appSelectors.getLocationWithId(state)
})

const mapDispatchToProps = (dispatch) => ({})

export default connect<{}, {}, ScanFilterPassedProps>(mapStateToProps, mapDispatchToProps)(ScanFilter)



// WEBPACK FOOTER //
// ./src/routes/scans/components/ScanFilter.component.tsx